import React, { useEffect, useState } from 'react';
import { FaOptionIcon } from '@europrocurement/l2d-icons';
import { Link } from 'react-router-dom';
import { IconName } from '@fortawesome/fontawesome-svg-core';
import { Box, useTheme } from '@mui/material';
import { DossierOpenSearch } from '@europrocurement/l2d-domain';
import { LegalAnnoucement } from '@europrocurement/l2d-modules/modules/Dossiers/types';
import { DossierArticle, useDossierProcessesActionsAndRender } from '../../hooks';

export type DossierArticleProcessIconProps = {
    icon: IconName;
    title: string;
    target?: string;
    execOnClick?: () => void;
};

export type DossierArticleProcessIconsProps = {
    article: DossierArticle;
    dossier: DossierOpenSearch;
    validatorTypeId: number;
    legalAnnoucements: Array<LegalAnnoucement>;
};

const DossierArticleProcessIcons: React.FunctionComponent<DossierArticleProcessIconsProps> =
    function ({ article, dossier, validatorTypeId, legalAnnoucements }) {
        const [icons, setIcons] = useState<Array<DossierArticleProcessIconProps>>();
        const { palette } = useTheme();
        const { getItemIcons } = useDossierProcessesActionsAndRender();

        useEffect(() => {
            if (article) {
                setIcons(getItemIcons(article, dossier, validatorTypeId, legalAnnoucements));
            }
            // eslint-disable-next-line react-hooks/exhaustive-deps
        }, [article, legalAnnoucements]);

        const wrapperSx = {
            display: 'flex',
            gap: '0 5px',
        };

        const iconSx = {
            color: palette.grey[600],
            fontSize: '12px',
        };

        const renderIcon = (icon: DossierArticleProcessIconProps) => {
            // Link icon with url in new tab
            if (icon.target) {
                return (
                    <Link
                        key={icon.title}
                        to={icon.target || ''}
                        target="_blank"
                        title={icon.title}
                    >
                        <FaOptionIcon
                            sx={iconSx}
                            icon={['fad', icon.icon]}
                        />
                    </Link>
                );
            }
            // Icon with an onClick function
            if (Object.hasOwn(icon, 'execOnClick')) {
                return (
                    <Box
                        sx={{ cursor: 'pointer' }}
                        key={icon.title}
                        onClick={icon.execOnClick}
                    >
                        <FaOptionIcon
                            sx={iconSx}
                            icon={['fad', icon.icon]}
                        />
                    </Box>
                );
            }

            return (
                <FaOptionIcon
                    key={icon.title}
                    icon={['fad', icon.icon]}
                    sx={{ ...iconSx, cursor: 'pointer' }}
                />
            );
        };

        return <Box sx={wrapperSx}>{icons && icons.map((icon) => renderIcon(icon))}</Box>;
    };

export default DossierArticleProcessIcons;
